import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Card, CardBody, Container, Input, Button, Label, Row, Col, Form, FormGroup } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { useFormik } from 'formik';
import TableContainer from 'components/Common/TableContainer';
import * as Yup from 'yup';
import Select from 'react-select';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTable, useSortBy, useGlobalFilter } from "react-table";
import { getRepCompletedWorkOrderListAPIURL } from 'BaseComponentAPI/RepCompletedWorkOrderAPI';

<style>
    {`
  .react-datepicker__triangle {
    left: 50%!important;
    transform: translateX(-50%);
  }
`}
</style>


const RepCompletedWorkOrdersList = () => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";

    const navigate = useNavigate();

    const location = useLocation();

    const { fromDate, toDate, triggerFetch = false } = location.state || {};

    // console.log("Received From:", fromDate, "To:", toDate, "triggerFetch:", triggerFetch);

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const [pendingData, setPendingData] = useState([]);
    const [completedData, setCompletedData] = useState([]);

    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loaderOption, setLoaderOption] = useState(false);
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);
    // Today's date
    const today = new Date();
    // Date 15 days ago
    const past14Days = new Date();
    past14Days.setDate(today.getDate() - 14);

    const past12Days = new Date();
    past12Days.setDate(today.getDate() - 12);

   

    useEffect(() => {
        if (triggerFetch) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);


    useEffect(() => {
        if (triggerFetch == true && fromDate && toDate) {
            formik.setFieldValue("startDate", moment(fromDate, "DD/MM/YYYY").toDate());
            formik.setFieldValue("endDate", moment(toDate, "DD/MM/YYYY").toDate());
            //console.log(fromDate + ' - ' + toDate);
            fetchWorkOrdersData(fromDate, toDate);
        }
    }, [triggerFetch]);


    // Handle date change (for both startDate and endDate)
    const handleDateChange = (date, field) => {
        setPendingData([]);
        setCompletedData([]);
        if (field === "startDate") {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
        formik.setFieldValue(field, date);
    };

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        // if (pendingData.length != 0) {
        //     if (authUser.headers && Object.keys(authUser.headers).length > 0) {
        //         // console.log(`API URL: ${getUserAudioRecordingsAPIURL}?employeeUUID=${values.employeeId}&journeyDate=${moment(values.date).format("DD/MM/YYYY")}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}}`);

        //         try {
        //             const response = await axios.get(
        //                 `${getUserAudioRecordingsAPIURL}?employeeUUID=${formik.values.employeeId}&startDate=${moment(formik.values.startDate).format("DD/MM/YYYY")}&endDate=${moment(formik.values.endDate).format("DD/MM/YYYY")}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
        //                 {
        //                     headers: { ...authUser.headers },
        //                     'Authorization': `Bearer ${authUser.headers.access_token}`
        //                 }
        //             );

        //             if (response.data.responseMsg == "Records not found") {
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //                 openPopup('Records Not Found.', 'error')
        //             }
        //             else if (response.data.responseMsg == "Success") {
        //                 setPendingData(response.data.data.items);
        //                 setTotalPages(response.data.data.totalPages)
        //                 setTotalItems(response.data.data.totalItems);
        //                 setNextPage(response.data.data.nextPage);
        //                 setPreviousPage(response.data.data.previousPage);
        //                 setCurrentPage(response.data.data.currentPage);
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //             }
        //             else {
        //                 console.error('API Response Error:', response.data.responseMsg);
        //                 setLoaderOption(false);
        //                 setDisableSaveBtn(false);
        //                 openPopup(response.data.responseMsg, 'error')
        //             }
        //         } catch (error) {
        //             console.error('Error fetching data:', error);
        //             setLoaderOption(false);
        //             setDisableSaveBtn(false);
        //             openPopup("Requested Data Not Found / 404", 'warn')
        //         }
        //         //  finally {
        //         //     setLoaderOption(false);
        //         // }
        //     }
        // }
    };

    // 🔹 Fetch Work Orders and auto-load Scheduler + Field Executive data
    const fetchWorkOrders = async (url, setter, { loadSupportLists = false } = {}) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    ...authUser.headers,
                    Authorization: `Bearer ${authUser.headers.access_token}`,
                },
            });

            const msg = response.data.responseMsg;

            if (msg == "Records not found") {
                setter([]);
                return { data: [], msg };  // ⭐ return msg also
            }

            if (msg == "Success") {
                const data = response.data.data || [];
                setter(data);


                return { data, msg };  // ⭐ return msg
            }

            return { data: [], msg };

        } catch (error) {
            console.error("Error fetching data:", error);
            return { data: [], msg: "Requested Data Not Found / 404" };
        }
    };

    
    const fetchWorkOrderList = async (woUUID) => {
        try {
            const res = await axios.get(
                `${getWorkOrderListAPIURL}?userUUID=${authUser.headers.userUUID}&woUUID=${woUUID}`,
                {
                    headers: {
                        ...authUser.headers,
                        Authorization: `Bearer ${authUser.headers.access_token}`,
                    },
                }
            );
            if (res.data.responseMsg == "Success") {
                setWoStatusData(res.data.data || []);
            } else {
                console.error("Work Order API Response Error:", res.data.responseMsg);
            }
        } catch (err) {
            console.error("Error fetching work order list:", err);
            openPopup("Requested Data Not Found / 404", "warn");
        }
    };


    let fePrefetchDone = false;
    // 🔹 Master function to fetch all Work Orders
    const fetchWorkOrdersData = async (startDate, endDate) => {
        setLoaderOption(true);
        const userUUID = authUser.headers.userUUID;

        // Reset FE prefetch flag
        fePrefetchDone = false;
       
        // 2️⃣ Fetch completed work orders
        const completedUrl =
            `${getRepCompletedWorkOrderListAPIURL}?userUUID=${userUUID}&startDate=${startDate}&endDate=${endDate}`;

        const completedResult = await fetchWorkOrders(completedUrl, setCompletedData, { loadSupportLists: true });

        if (completedResult.data.length == 0) {
            openPopup(completedResult.msg || "No completed work orders found", "warn");
        }
         
        setLoaderOption(false);       

       
    };

    
    const formik = useFormik({
        initialValues: {
            startDate: new Date(),
            endDate: new Date(),
        },
        validationSchema: Yup.object({
            startDate: Yup.date()
                .required('Start Date is required'),

            endDate: Yup.date()
                .required('End Date is required')
                .test(
                    "date-range",
                    "End Date should not be before Start Date and not more than 3 days later",
                    function (value) {
                        const { startDate } = this.parent;
                        if (startDate && value) {
                            const diff = moment(value).diff(moment(startDate), "days");

                            // ✅ allow same day (0) up to 5 days later
                            return diff >= 0 && diff < 4;
                        }
                        return true;
                    }
                ),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setPendingData([]);
            setCompletedData([]);

            if (!authUser.headers || Object.keys(authUser.headers).length == 0) return;

            const startDate = moment(values.startDate).format("DD/MM/YYYY");
            const endDate = moment(values.endDate).format("DD/MM/YYYY");

            // 🔹 Step 1: Fetch work orders first
            await fetchWorkOrdersData(startDate, endDate);

            setDisableSaveBtn(false);
            setLoaderOption(false);
        }


    });

    

    const completedColumns = useMemo(
        () => [
            {
                header: "Sr.",
                accessorKey: "woSeqNo",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "WO Serial",
                accessorKey: "woSerialNo",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Type",
                accessorKey: "woType",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Date",
                accessorKey: "woDate",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Time",
                accessorKey: "woTime",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "WO Status",
                accessorKey: "woStatus",
                enableColumnFilter: false,
                enableSorting: false,
            },                       
            {
                header: "Product Details",
                accessorKey: "product",
                enableColumnFilter: true,
                enableSorting: true,
            },            
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Cust. Mobile",
                accessorKey: "customerMobile",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Cust.Sec.Mob",
                accessorKey: "customerSecondryMobile",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Scheduler Name",
                accessorKey: "schedulerName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Field Executive",
                accessorKey: "fieldExecutiveName",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Pay Mode",
                accessorKey: "paymentMode",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Amount ₹",
                accessorKey: "amount",
                enableColumnFilter: true,
                enableSorting: true,
            }, 
             {
                header: "Received ₹",
                accessorKey: "amountReceived",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Balance ₹",
                accessorKey: "amountBalance",
                enableColumnFilter: true,
                enableSorting: true,
            },
            
            {
                header: "Detail Address",
                accessorKey: "woDetailAddress",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Service Location",
                accessorKey: "woServiceLocation",
                enableColumnFilter: true,
                enableSorting: true,
            },
           
            {
                header: "Landmark 1",
                accessorKey: "woLandmark1",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Landmark 2",
                accessorKey: "woLandmark2",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Sub Area",
                accessorKey: "woSubArea",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Area",
                accessorKey: "woArea",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "EnquiryNo",
                accessorKey: "enquiryId",
                enableColumnFilter: true,
                enableSorting: true,
            },
            {
                header: "Enq Date",
                accessorKey: "enquiryDate",
                enableColumnFilter: true,
                enableSorting: true,
            },
            
            {
                header: "Ori.Header",
                accessorKey: "enqOriginatedHeader",
                enableColumnFilter: true,
                enableSorting: true,
            },

            {
                header: "WO Booked By",
                accessorKey: "woBookedUserName",
                enableColumnFilter: true,
                enableSorting: true,
            },


            {
                header: "Action",
                accessorKey: "action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => (
                    <Button
                        color="success"
                        size="sm"
                        type='button'
                        onClick={() => {
                            const startDate = moment(formik.values.startDate).format("DD/MM/YYYY");
                            const endDate = moment(formik.values.endDate).format("DD/MM/YYYY");
                            //console.log('from button: ' + startDate + ' - ' + endDate + ' for - ' + formik.values.startDate);    
                            navigate(`/RepWorkOrderDetails/${row.original.woUUID}/${row.original.woExeUUID}`, {
                                state: {
                                    fromDate: startDate,
                                    toDate: endDate
                                }
                            });
                        }}
                    >
                        WO Details
                    </Button>
                ),
            }
        ],
        [ formik.values, navigate]
    );

  

    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Work Order" breadcrumbItem="Completed Work Order List" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Work Order" breadcrumbItem="Completed Work Order List" />
                            <Card>
                                <CardBody className="border-bottom">
                                    <div style={{ padding: '20px' }}>

                                        <Form onSubmit={formik.handleSubmit}>

                                            <Row className='my-3'>
                                                {/* From Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="startDate">Start Date</Label>

                                                        <DatePicker
                                                            selected={formik.values.startDate}
                                                            onChange={(date) => {
                                                                handleDateChange(date, "startDate");
                                                                formik.setFieldValue("endDate", null);  // ⭐ MUST BE NULL
                                                            }}
                                                            minDate={past14Days}   // ❌ Disable dates before 30 days
                                                            maxDate={today} 
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select Start Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",

                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />


                                                        {formik.touched.startDate && formik.errors.startDate && (
                                                            <div style={{ color: "red", marginTop: "5px" }}>
                                                                {formik.errors.startDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>


                                                {/* To Date Picker */}
                                                <Col md="4">
                                                    <FormGroup>
                                                        <Label for="endDate">End Date</Label>
                                                        <DatePicker
                                                            selected={formik.values.endDate}
                                                            onChange={(date) => handleDateChange(date, "endDate")}
                                                            minDate={moment(formik.values.startDate).add(0, "days").toDate()}
                                                            maxDate={moment.min(
                                                                    moment(formik.values.startDate).add(2, "days"),
                                                                    moment()
                                                                ).toDate()
                                                            }
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Select End Date"
                                                            popperPlacement="bottom"
                                                            portalId="root"
                                                            renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        borderBottom: "1px solid #eee",
                                                                        background: "#fff",
                                                                    }}
                                                                >
                                                                    <button
                                                                        onClick={decreaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ◀
                                                                    </button>

                                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                                        {date.toLocaleDateString("en-US", {
                                                                            month: "long",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>

                                                                    <button
                                                                        onClick={increaseMonth}
                                                                        type="button"
                                                                        style={{
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ▶
                                                                    </button>
                                                                </div>
                                                            )}
                                                        />
                                                        {formik.touched.endDate && formik.errors.endDate && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {formik.errors.endDate}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                {/* Submit Button */}
                                                <Col md="12">
                                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>

                                  

                                    {
                                        completedData.length != 0
                                            ?
                                            <div className='mt-3'>
                                                {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> */}
                                                <h5 className="card-title mb-3" style={{ color: '#b72323' }}>
                                                    Completed Work Orders Between {" "}
                                                    {formik.values.startDate
                                                            ? moment(formik.values.startDate).format("DD MMM YYYY")
                                                            : "—"}{" "}
                                                        To{" "}
                                                        {formik.values.endDate
                                                            ? moment(formik.values.endDate).format("DD MMM YYYY")
                                                            : "—"}
                                                    

                                                    
                                                </h5>
                                                <TableContainer
                                                    columns={completedColumns}
                                                    data={completedData || []}
                                                    isGlobalFilter={true}
                                                    isPagination={false}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={false}
                                                    tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: "",
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}

                                                />
                                            </div>
                                            :
                                            ''
                                    }
                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            );
        }
    }
}

RepCompletedWorkOrdersList.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(RepCompletedWorkOrdersList);